module.exports = __webpack_public_path__ + "static/media/Zhaojing.dfe4e154.png";